import { render, staticRenderFns } from "./detecation-template-view.vue?vue&type=template&id=4c6856cf&scoped=true"
import script from "./detecation-template-view.vue?vue&type=script&lang=ts"
export * from "./detecation-template-view.vue?vue&type=script&lang=ts"
import style0 from "./detecation-template-view.vue?vue&type=style&index=0&id=4c6856cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6856cf",
  null
  
)

export default component.exports